export const SESSION_AUTH_TOKEN = 'auth_token';

export const SESSION_TNC = 'tnc';

